import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import type { PriceRange } from './prices';
import { formatPrice } from './prices';

type ExperiencePriceProps = {
  priceRange?: PriceRange;
};

export const ExperiencePrice = ({ priceRange }: ExperiencePriceProps) => {
  if (!priceRange) {
    return <div className="er-price">{formatPrice(0)}</div>;
  }

  const { min, max } = priceRange;

  return (
    <div className="er-price">
      {formatPrice(min)}
      {max > min && (
        <Tooltip
          title={`Rate depends on the day (min ${formatPrice(
            min
          )}, max ${formatPrice(max)})`}
        >
          <InfoCircleOutlined />
        </Tooltip>
      )}
    </div>
  );
};
